import { Accessor, createMemo } from 'solid-js'
import { Nullable } from '../../../typescript'
import { Engine } from '../engine/Engine.type'
import findById from '../findById'
import { Player } from './Player.type'
import { useSelectedPlayerIdSignal } from '../../../rx/signal/useSelectedPlayerIdSignal'

export default function createSelectedPlayerMemo(engine: Engine): Accessor<Nullable<Player>> {
  const [getSelectedPlayerId] = useSelectedPlayerIdSignal(engine)
  const selectedPlayer = createMemo<Nullable<Player>>(() => {
    const players = engine.state.players
    const playerId = getSelectedPlayerId()

    return findById(players, playerId)
  })
  return selectedPlayer
}
